import { render, staticRenderFns } from "./CabinetBedOption.vue?vue&type=template&id=3f383e42"
import script from "./CabinetBedOption.vue?vue&type=script&lang=js"
export * from "./CabinetBedOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports